import React, { useEffect } from "react";
import withRouter from "components/Common/withRouter";
import { del } from "../../helpers/api_helper";
//redux
import { useNavigate, useParams } from "react-router-dom";
import { REMOVE_DELIVERY_TYPE } from "helpers/api_endpoints";

const RemoveDeliveryType = () => {
    const history = useNavigate();
    const params = useParams();
    const id = params.id;
    const navigate = useNavigate();

    useEffect(() => {
        del(REMOVE_DELIVERY_TYPE, { id })
            .then(response => {
                navigate('/delivery-types', { state: { successMsg: 'deleted SuccessFully' } });
            })
            .catch(error => {
                console.log(error);
            })
    });

    return <></>;
};

export default withRouter(RemoveDeliveryType);